module.exports = __webpack_public_path__ + "media/images/athletes/2858-c037b3b22775999b3c035a356a165efc.png";